import Helpers from '@support/Helpers';
/**
 * State
 * @type {Object}
 */
const state = () => ({
    list: []
});

/**
 * Getters
 * @type {Object}
 */
const getters = {}

/**
 * Actions
 * @type {Object}
 */
const actions = {

    success({commit}, {title, text}) {
        commit('add', { title, text, type:'success' });
    },

    alert({commit}, {title, text}) {
        commit('add', { title, text, type:'alert' });
    },

    warning({commit}, {title, text}) {
        commit('add', { title, text, type:'warning' });
    },

    info({commit}, {title, text}) {
        commit('add', { title, text, type:'info' });
    },

    remove({commit}, id) {
        commit('remove', id);
    }
}

/**
 * Mutations
 * @type {Object}
 */
const mutations = {
    add(state, {title, text, type} ) {
        state.list.push({
            title,
            text,
            type,
            id: Helpers.uid()
        })
    },

    remove(state, id) {
        let index = state.list.findIndex( s => s.id == id );

        if ( index >= 0 ) {
            state.list.splice(index, 1);
        }
    }
}

export default {
	namespaced: true,
	state,
	getters,
	actions,
	mutations
}
